import { type SpotlightStore } from './types';

export const initialState: SpotlightStore = {
	spotlights: {},
};
